/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Content_TextbooksInputs */

const en_onboarding_content_textbooks = /** @type {(inputs: Onboarding_Content_TextbooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textbooks`)
};

const es_onboarding_content_textbooks = /** @type {(inputs: Onboarding_Content_TextbooksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libros de texto`)
};

/**
* | output |
* | --- |
* | "Textbooks" |
*
* @param {Onboarding_Content_TextbooksInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_content_textbooks = /** @type {((inputs?: Onboarding_Content_TextbooksInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Content_TextbooksInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_content_textbooks(inputs)
	return en_onboarding_content_textbooks(inputs)
});